@let tPrefix = 'features.staffMonitor.configureParticipantDialog';

<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t(`${tPrefix}.title`) }}</h2>

  <form #formDirective="ngForm" [formGroup]="form" (submit)="save()">
    <mat-dialog-content>
      <mat-form-field class="w-100">
        <mat-label>{{ t(`${tPrefix}.mindDeviceName`) }}</mat-label>

        <input
          data-testid="mind-device-name-input"
          id="mindDeviceName"
          matInput
          [formControl]="mindDeviceNameControl"
        />

        <mat-error>
          {{ mindDeviceNameControl.errors | validatorError }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>{{ t(`${tPrefix}.participantName`) }}</mat-label>

        <input
          data-testid="participant-name-input"
          id="participantName"
          matInput
          [formControl]="participantNameControl"
        />

        <mat-error>
          {{ participantNameControl.errors | validatorError }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>{{ t(`${tPrefix}.participantThreshold`) }}</mat-label>

        <input
          data-testid="participant-threshold-input"
          id="participantThreshold"
          matInput
          type="number"
          [formControl]="participantThresholdControl"
        />

        <mat-error>
          {{ participantThresholdControl.errors | validatorError }}
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button
        data-testid="submit-button"
        matButton="filled"
        type="submit"
        [disabled]="formDirective.invalid && formDirective.submitted"
      >
        {{ t('common.save') }}
      </button>

      <button data-testid="cancel-button" mat-button type="button" (click)="cancel()">
        {{ t('common.cancel') }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
